<template>
	<div class="annual">
		<div class="annual_cont">
			<div class="crumbs">当前位置：论坛首页-论坛视频</div>
			<div class="annual_list">
				<div class="list" v-for="(item,index) in wenzhang">
					<div class="image"  @click="checkVideoFun(item.url,item.videoMemberType)">
						<img :src="item.cover" class="list_bg" alt="">
						<div class="play"><img src="../../assets/wbanner_41.png" alt=""></div>
					</div>
					<div class="text">{{item.title}}</div>
				</div>
			</div>

			<!-- <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
				:options="playerOptions"></video-player> -->
			
			<div>
				<!-- 外层的遮罩 v-if用来控制显示隐藏 点击事件用来关闭弹窗 -->
				<div class="mask" v-if="videoState == true" @click="masksCloseFun"></div>
				<!-- 弹窗 -->
				<div class="videomasks" v-if="videoState == true">
					<div class="try" v-if="type==200">可试看3分钟，开通俱乐部会员免费看</div>
					<!-- 视频：h5的视频播放video -->
					<video :src="videoSrc" controls="controls" autoplay width="100%" height="100%">
					
					</video>
				</div>
			</div>
		</div>
		<el-pagination
		  background
		  layout="prev, pager, next"
		  :total="total"
		  :page-size="tablePage.pageSize"
		  :current-page="tablePage.pageNum"
		  @size-change="handleSizeChange"
		  @current-change="handlePageChange"
		  
		  >
		</el-pagination>
	</div>
</template>

<script>
	import { encrypt,decrypt, generatekey } from "@/plugins/des2.js"
	import qs from 'qs'
	import {VideoTypeList} from '../../api/api.js'
	export default {
		name: 'annual',
		data() {
			return {
				videoSrc: "",
				videoState: false,
				wenzhang:[],
				type:100,
				tablePage: {
					pageNum: 1, // 第几页
					pageSize: 20, // 每页多少条
				},
				total:1
			}
		},
		mounted() {
			this.VideoTypeList()
		},
		methods: {
			handlePageChange(currentPage) {
			  this.tablePage.pageNum = currentPage
		      this.VideoTypeList()
			  // 在此刷新数据
			},
			handleSizeChange(pageSize) {
				console.log(pageSize)
			  this.tablePage.pageSize = pageSize
			  // 在此刷新数据
			},
			bofang() {},
			//点击按钮出现弹窗播放视频
			checkVideoFun(url,type) {
					this.videoSrc=url
				this.videoState = true;
			this.type=type

			},
			masksCloseFun() {
				this.videoState = false;

			},
			//年会视频接口
			async VideoTypeList(){
				//加密
				const key = localStorage.getItem('key')// generatekey(8); // 也可直接指定固定key值 let key = 'des';  
				let time = parseInt(new Date().getTime() / 1000)
				let data={
				      	token: time+"&"+localStorage.getItem('token'),
				      	os: "Web",
				      	type:100,
						page:this.tablePage.pageNum
				}
				      //如果是对象/数组的话，需要先JSON.stringify转换成字符串
				const encrypts = encrypt(JSON.stringify(data), key, key);
				let encrypts1 = encrypts.replace(/\//g,"@@");
				let encrypts2 = encrypts1.replace(/[+]/g,"$$$$");
				let requetp={
						p:encrypts2
				}	
				let res=await VideoTypeList(qs.stringify(requetp))
				//解密
				let res1=res.data
				let encrypts3 = res1.replace(/@@/g, "/");
				let encrypts4 = encrypts3.replace(/\$\$/g, "+");
				const dess = decrypt(encrypts4,key,key);  
				this.wenzhang=JSON.parse(dess).d.Data
				this.total=JSON.parse(dess).d.Total
			}
		},
	}
</script>

<style>
	.try{
		position: absolute;
		    bottom: 20%;
		    left: 4%;
		    background: #8a8c8d;
		    color: #fff;
			padding: 10px;
			border-radius: 8px;
			opacity: 0.8;
			z-index: 999;
	}
	.videomasks video{
		width: 550px;object-fit: cover;
	}
	.mask {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background-color: #000000;
		opacity: 0.6;
		z-index: 998;
	}

	/* 内容层 z-index要比遮罩大，否则会被遮盖 */
	.videomasks {
		max-width: 1200px;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 999;
		/* transform: translate(-50%, -50%); */
	}

	.annual .crumbs {
		width: 1200px;
		margin: 0 auto;
		margin-top: 30px;
		font-size: 16px;
		color: #999999;
	}

	.annual .annual_list {
		width: 1230px;
		margin: 0 auto;
		margin-top: 30px;
		display: flex;
		flex-wrap: wrap;
		padding-bottom: 30px;
	}

	.annual .annual_list .list {
		width: 23%;
		margin: 0 1%;
		margin-bottom: 25px;
	}

	.annual .annual_list .list .image {
		position: relative;
		margin-bottom: 15px;
	}

	.annual .annual_list .list .image .list_bg {
		width: 280px;
		height: 280px;
		object-fit: cover;
		border-radius: 10px;
	}

	.annual .annual_list .list .image .play {
		z-index: 99;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: rgba(0, 0, 0, 0.4);
		width: 100%;
		text-align: center;
		height: 98%;
		align-items: center;
		display: flex;
		justify-content: center;
		border-radius: 10px;
		opacity: 0;
		transition: 0.5s;
	}

	.annual .annual_list .list .image:hover .play {
		opacity: 1;
		transition: 0.5s;
	}

	.annual .annual_list .list .text {
		font-size: 18px;
		color: #333;
	}
	@media screen and (max-width: 1400px){
		.annual .crumbs {
		    width: 900px;
		    margin-top: 20px;
		    font-size: 16px;
		}
		.annual .annual_list {
		    width: 900px;	
		    margin-top: 20px;
		    padding-bottom: 20px;
		}
		.annual .annual_list .list .image .list_bg{
			width: 100%;
			height: 156px;
		}
		.annual .annual_list .list .image {
		    position: relative;
		    margin-bottom: 10px;
		}
		.videomasks {
		    max-width: 900px;
		}
	}
	@media screen and (max-width: 1000px){
		.annual .crumbs{
			width: 750px;
			margin-top: 10px;
			font-size: 16px;
		}
		.annual .annual_list {
		    width: 750px;
		    margin-top: 20px;
		    padding-bottom: 20px;
		}
		.annual .annual_list .list .text {
		    font-size: 16px;
		    color: #333;
		}
		.videomasks {
		    max-width: 750px;
		}
	}
	@media screen and (max-width: 768px){
		.annual{
			margin-top: 80px;
		}
		.annual .crumbs {
		    width: 98%;
		    margin-top: 0px;
		    font-size: 14px;
		}
		.annual .annual_list .list {
		    width: 49%;
		    margin: 0 0%;
		    margin-bottom: 15px;
		}
		.annual .annual_list {
		    width: 98%;
		    margin-top: 10px;
		    padding-bottom: 10px;
			justify-content: space-between;
		}
		.annual .annual_list .list .image .list_bg {
		    width: 100%;
		    height: 200px;
		}
		.annual .annual_list .list .image {
		    position: relative;
		    margin-bottom: 3px;
		}
		.annual .annual_list .list .text {
		    font-size: 14px;
		    color: #333;
		}
	}
</style>